import '../css/app.css'
import Layout from './Layouts/Layout'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { createInertiaApp } from '@inertiajs/react'
import { ReactNode, StrictMode, useEffect } from 'react'
import i18n, { visitorLanguage } from '@/lib/i18n'
import { markHydrated } from '@/hooks/use-hydrated'
import { pageTitle } from '@/lib/page-title'

/**
 * Runs once the server's HTML has been taken over. Until then the app speaks
 * English, as the server did; an effect here is the first moment it is safe to
 * say anything else.
 */
function TakenOver({ children }: { children: ReactNode }) {
  useEffect(() => {
    i18n.changeLanguage(visitorLanguage)
  }, [])

  return children
}

createInertiaApp({
  title: pageTitle,
  resolve: (name) => {
    const pages = import.meta.glob('./Pages/**/*.tsx', { eager: true })
    const page: any = pages[`./Pages/${name}.tsx`]
    page.default.layout = page.default.layout || ((page: ReactNode) => <Layout children={page} />)
    return page
  },
  setup({ el, App, props }) {
    /* The server drew the page: take over its HTML as it stands, then turn to the visitor's language. */
    if (el.hasChildNodes()) {
      hydrateRoot(
        el,
        <TakenOver>
          <App {...props} />
        </TakenOver>
      )

      return
    }

    /* No server-side rendering, as in local development: nothing to wait for. */
    markHydrated()

    createRoot(el).render(
      <StrictMode>
        <App {...props} />
      </StrictMode>
    )
  },
  progress: {
    color: '#f00000',
  },
})
